import React from 'react';
import { constructMediaUrl } from '../../../api/helpers';
import ClipPlayer from '../ClipPlayer';
import NavigationControls from './NavigationControls';

interface VideoGalleryProps {
  urls: string[];
  currentIndex: number;
  setCurrentIndex: (i: number) => void;
}

const VideoGallery: React.FC<VideoGalleryProps> = ({
  urls,
  currentIndex,
  setCurrentIndex,
}) => (
  <div>
    <div className="rounded-lg overflow-hidden border border-white/5 bg-black">
      <ClipPlayer clipUrl={constructMediaUrl(urls[currentIndex])} />
    </div>
    {urls.length > 1 && (
      <NavigationControls
        currentIndex={currentIndex}
        total={urls.length}
        onPrev={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
        onNext={() => setCurrentIndex(Math.min(urls.length - 1, currentIndex + 1))}
      />
    )}
  </div>
);

export default VideoGallery;